<template>
  <EquivalentExtractionCopyBase
    :subtitle="'Browse finalized qualitative extractions from equivalent reviews.'"
    :cache-key="study.id"
    :fetch-studies="fetchStudies"
    @copy="emit('copy', $event)"
  >
    <template #preview="{ extraction }">
      <div
        v-if="extraction.value"
        class="text-sm text-blue-900 prose prose-sm"
        v-html="extraction.value"
      />
      <div v-else class="text-sm text-gray-500 italic">No value extracted</div>
    </template>
  </EquivalentExtractionCopyBase>
</template>

<script setup lang="ts">
import { injectStrict } from "@app/utils/injectStrict";
import { EvidenceServiceApiKey } from "@app/injectionKeys";
import { ReviewItem } from "@core/domain/models/reviewItem.model";
import EquivalentExtractionCopyBase from "./EquivalentExtractionCopyBase.vue";
import type { EquivalentStudyEntry } from "./EquivalentExtractionCopyBase.vue";

const props = defineProps<{
  study: ReviewItem;
}>();

const emit = defineEmits<{
  copy: [value: string];
}>();

const evidenceService = injectStrict(EvidenceServiceApiKey);

async function fetchStudies(): Promise<EquivalentStudyEntry<string>[]> {
  const response = await evidenceService.api.reviewItemsControllerGetEquivalentFinalizedExtraction(
    props.study.id,
  );
  return response.data.map((s) => ({
    reviewSeriesName: s.reviewSeriesName,
    study: {
      id: s.id,
      title: s.title,
      extractions: s.extractions.map((e) => ({
        label: e.label,
        attributeStructureId: e.attributeStructureId,
        value: e.extractionValue,
      })),
    },
  }));
}
</script>
